import React from 'react';
import ReactDOM from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';

const DeleteConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Delete Confirmation", 
  message = "Are you sure you want to delete this item? This action is permanent and cannot be undone.",
  confirmText = "Delete Permanently",
  cancelText = "Cancel",
  isLoading = false 
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-gray-900/40 backdrop-blur-md animate-fadeIn"
        onClick={!isLoading ? onClose : undefined}
      />
      
      {/* Modal Container */}
      <div className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl shadow-gray-900/20 overflow-hidden animate-slideUp border border-gray-100">
        {/* Close Button */}
        <button 
          onClick={onClose}
          disabled={isLoading}
          className="absolute top-6 right-6 p-2 text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-all disabled:opacity-50"
        >
          <X size={20} />
        </button>

        <div className="p-8 sm:p-10">
          {/* Icon Header */}
          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center text-red-500">
              <AlertTriangle size={28} />
            </div>
            <div>
              <h3 className="text-xl font-black text-gray-900 tracking-tighter uppercase">
                {title}
              </h3>
              <p className="text-[10px] font-bold text-red-500 uppercase tracking-[0.2em] opacity-80">
                Action Required
              </p>
            </div>
          </div>

          {/* Message Content */}
          <div className="mb-10">
            <p className="text-gray-500 font-medium leading-relaxed">
              {message}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-center gap-3 mt-4">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-6 py-2.5 bg-gray-50 text-gray-400 font-bold text-[10px] uppercase tracking-widest rounded-xl hover:bg-gray-100 hover:text-gray-900 transition-all disabled:opacity-50"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-8 py-2.5 bg-gray-900 text-white font-bold text-[10px] uppercase tracking-widest rounded-xl hover:bg-red-600 shadow-lg shadow-gray-200 transition-all flex items-center justify-center gap-2 group disabled:opacity-50 active:scale-95"
            >
              {isLoading ? (
                <div className="w-3.5 h-3.5 border-2 border-white/20 border-t-white rounded-full animate-spin" />
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmModal;
